import type { SuperEnhancementChatMessageResponseDto } from 'app/API/models';

export const sortSuperEnhancementMessages = (messages: SuperEnhancementChatMessageResponseDto[]) =>
  [...messages].sort(
    (left, right) => Date.parse(left.createdAt) - Date.parse(right.createdAt) || left.id.localeCompare(right.id),
  );
